import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { PaymentTypesType } from 'services/api/PaymentApi/types/common'

import { IUser } from 'shared/models/User'

import { selectLocaleDict } from 'features/locale/selectors'

import { replaceTemplateValue, templateAmountByPaymentType } from '../../data'

import './TemplateAmount.scss'

type TemplateAmountProps = {
  currency: string
  balance?: IUser['balance']
  paymentType: PaymentTypesType
  changeValue(value: number): void
}

const b = block('template-amount')

export const TemplateAmount: React.FC<TemplateAmountProps> = ({ paymentType, currency, balance, changeValue }) => {
  const locale = useSelector(selectLocaleDict, shallowEqual).payment
  const templatesByType = useMemo(() => templateAmountByPaymentType[paymentType], [paymentType])
  const renderItems = useMemo(
    () =>
      templatesByType.map((it, ind) => {
        const onTemplateClick = () => {
          let templateAmount = it
          if (typeof templateAmount === 'string') {
            templateAmount = replaceTemplateValue({ balance })?.[templateAmount] || 0
          }

          changeValue(templateAmount)
        }
        return (
          <div key={`${it}-${ind}`} className={b('item-container')} onClick={onTemplateClick}>
            <div className={b('item-content')}>{String(it).replace('$USER_BALANCE', `${locale.AllPayment}`)}</div>
          </div>
        )
      }),
    [balance, changeValue, templatesByType, locale],
  )

  if (!templatesByType.length) return null

  return <div className={b({ paymentType })}>{renderItems}</div>
}
